import { CardStack } from '../card-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { Orientation } from '../../../../enum/dto/orientation.enum';

export abstract class TwoByTwoCardStack extends CardStack {
  getCardHeightInInches(): number {
    return 2;
  }

  getCardWidthInInches(): number {
    return 2;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 20;
  }

  nColumns(): number {
    return 4;
  }

  nRows(): number {
    return 5;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Landscape;
  }
}
